<template>
    <v-row justify="center">
        <v-col xs=12 sm="7" md="6">
            <v-container fluid v-if="$route.name === 'Login'">
                <login-form></login-form>
            </v-container>
            <v-container fluid v-if="$route.name === 'SignUp'">
                <sign-up-form></sign-up-form>
            </v-container>
            <v-container fluid v-if="$route.name === 'PasswordReset'">
                <password-reset></password-reset>
            </v-container>
            <v-container fluid v-if="$route.name === 'SendMessagePasswordReset'">
                <send-message-password-reset></send-message-password-reset>
            </v-container>
        </v-col>
    </v-row>
</template>

<script>
import LoginForm from '../components/login/LoginForm'
import SignUpForm from '../components/login/SignUpForm'
import PasswordReset from '../components/login/PasswordReset'
import SendMessagePasswordReset from '../components/login/SendMessagePasswordReset'

export default {
    components: {
        LoginForm,
        SignUpForm,
        PasswordReset,
        SendMessagePasswordReset
    }
}
</script>
